<template>
    <div>
        <el-table :data="compare" border style="width:97%">
            <el-table-column label="修改项" prop="name"></el-table-column>
            <el-table-column label="修订后" prop="after">
                <template slot-scope="scope">
                    <span v-html="scope.row.after"></span>
                </template>
            </el-table-column>
            <el-table-column label="修改前" prop="before">
                <template slot-scope="scope">
                    <span v-html="scope.row.before"></span>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
    export default {
        name: "zjCor",
        props: {
            edit_content: {
                required: true
            }
        },
        data() {
            return {
                compare: []
            }
        },
        created(){
            this.setQuestionNum();
            this.setDayDownload();
            this.setPersonDown();
            this.setBatch();
        },
        methods:{
            setQuestionNum(){
                let day = {
                    name: '试题蓝数量设置',
                    before: '',
                    after: ''
                };
                let before = this.edit_content.before_content.limit_configure.question_num;
                let after = this.edit_content.content.limit_configure.question_num;
                if(before !== after){
                    after = "<span style='color: red'>"+after+"</span>";
                }
                day.before = before;
                day.after = after;
                this.compare.push(day);
            },
            setDayDownload(){
                let All = {
                    name: '试卷日下载次数',
                    before: '',
                    after: ''
                }
                let before = this.edit_content.before_content.limit_configure.paper_download;
                let after = this.edit_content.content.limit_configure.paper_download;
                if(before !== after){
                    after = "<span style='color: red'>"+after+"</span>";
                }
                All.before = before;
                All.after = after;
                this.compare.push(All);
            },
            setPersonDown(){
                let person = {
                    name: '个人/日下载限制',
                    before: '',
                    after: ''
                };
                let before =  this.edit_content.before_content.limit_configure.single_down_limit;
                let after =  this.edit_content.content.limit_configure.single_down_limit;
                if(before !== after){
                    after = "<span style='color: red'>"+after+"</span>";
                }
                person.before = before;
                person.after = after;
                this.compare.push(person);
            },
            setBatch(){
                this.edit_content.content.limit_configure.batch.map(i => {
                    if (i.subject_id === 0) return;
                    let subject = {
                        name: '',
                        before: '',
                        after: ''
                    }
                    subject.name = i.subject_name;
                    let before = '';
                    let after = '';

                    after += '小学：' + i.config.primary  + '<br/>';
                    after += '初中：' + i.config.middle + "<br/>";
                    after += '高中：' + i.config.high +  '<br/>';
                    let content = this.edit_content.before_content.limit_configure.batch.find(j=>{
                        return j.subject_id == i.subject_id;
                    });
                    before += '小学：' + content.config.primary  + '<br/>';
                    before += '初中：' + content.config.middle + "<br/>";
                    before += '高中：' + content.config.high +  '<br/>';
                    if(before !== after){
                        after = "<span style='color: red'>"+after+"</span>";
                    }
                    subject.before = before;
                    subject.after = after;
                    this.compare.push(subject);

                });
            },
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/order/recoder/zjCor.vue